/** طرح‌های وام ثابت بر اساس نوع نیروگاه (۵ کیلووات) — فقط اطلاعاتی */

export const LOAN_PLAN_TYPES = {
  ON_GRID_5KW: "ON_GRID_5KW",
  HYBRID_5KW: "HYBRID_5KW",
};

// مبالغ به ریال. سقف وام همه نیروگاه‌های مشمول وام: ۴ میلیارد ریال.
const SHARED_5KW_LOAN_AMOUNTS = {
  maxLoanAmount: 4_000_000_000,
  months: 60,
  annualInterestRate: 14,
  monthlyInstallment: 93_073_003,
  totalInterest: 1_584_380_180,
  finalRepayment: 5_584_380_180,
};

const ON_GRID_PLAN = {
  loanPlanType: LOAN_PLAN_TYPES.ON_GRID_5KW,
  planTitle: "متصل به شبکه — ۵ کیلووات",
  ...SHARED_5KW_LOAN_AMOUNTS,
};

const HYBRID_PLAN = {
  loanPlanType: LOAN_PLAN_TYPES.HYBRID_5KW,
  planTitle: "هیبریدی — ۵ کیلووات",
  ...SHARED_5KW_LOAN_AMOUNTS,
};

const OFF_GRID_UNAVAILABLE = {
  available: false,
  loanPlanType: null,
  planTitle: null,
  maxLoanAmount: null,
  months: null,
  annualInterestRate: null,
  monthlyInstallment: null,
  totalInterest: null,
  finalRepayment: null,
  availabilityLabel: "وام فعال نیست",
  unavailableMessage: "برای نیروگاه آفگرید در حال حاضر وام فعال نیست.",
};

const PENDING_SELECTION = {
  available: false,
  loanPlanType: null,
  planTitle: null,
  maxLoanAmount: null,
  months: null,
  annualInterestRate: null,
  monthlyInstallment: null,
  totalInterest: null,
  finalRepayment: null,
  availabilityLabel: "در انتظار انتخاب نوع نیروگاه",
  unavailableMessage: "پس از انتخاب نوع نیروگاه، اطلاعات وام نمایش داده می‌شود.",
};

/**
 * @param {string|number|null|undefined} powerPlantType
 * 1=On-grid, 2=Off-grid, 3=Hybrid, 4=Hybrid without battery
 */
export function resolvePlantLoanPlan(powerPlantType) {
  const key = powerPlantType != null && powerPlantType !== "" ? String(powerPlantType) : "";

  if (!key) {
    return { ...PENDING_SELECTION };
  }

  if (key === "2") {
    return { ...OFF_GRID_UNAVAILABLE };
  }

  if (key === "1") {
    return {
      available: true,
      availabilityLabel: "وام فعال است",
      unavailableMessage: null,
      ...ON_GRID_PLAN,
    };
  }

  // Hybrid (3) and Hybrid without battery (4) share the same 4B-rial plan.
  if (key === "3" || key === "4") {
    return {
      available: true,
      availabilityLabel: "وام فعال است",
      unavailableMessage: null,
      ...HYBRID_PLAN,
      ...(key === "4"
        ? { planTitle: "هیبریدی بدون باطری — ۵ کیلووات" }
        : {}),
    };
  }

  return { ...PENDING_SELECTION };
}

/** مقادیر مشتق‌شده برای ارسال فرم (هم‌خوان با طرح انتخاب‌شده) */
export function getDerivedLoanFormValues(powerPlantType) {
  const plan = resolvePlantLoanPlan(powerPlantType);
  if (!plan.available) {
    return {
      requestedLoanAmount: null,
      loanInstallmentMonths: null,
      loanPlanType: null,
    };
  }
  return {
    requestedLoanAmount: plan.maxLoanAmount,
    loanInstallmentMonths: plan.months,
    loanPlanType: plan.loanPlanType,
  };
}
